import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import { Box, Stack, Grid } from '@mui/material';
import DropdownSelector from '../dropdowns/DropdownSelector';
import ReactDropDownCalender from '../ReactDropDownCalender';
import { FormList, FormElement } from '../CommonFormComponents';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import FieldContractorUserService from '../../services/FieldContractorUsers';
import { messageUtility } from '../../utilities/messageUtility';
import { isNullOrEmpty } from '../../utilities/stringUtil';
import { WORK_HOUR_ZONES, REQUEST_PARAMS } from '../../utilities/constants';

export const LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS = {
  ALL: { ID: 0, NAME: '' },
  NOT_CONFIRM: { ID: 1, NAME: '未確認のデータのみを表示' },
};

export const KyReportSearchForm = ({
  state,
  callbacks,
  searchButtonRef,
  clearFlag,
}) => {
  const displaySearchParams = useMemo(() => {
    const filteredParamSearch = filteredParams(state.params);
    const result = _.flatMap(filteredParamSearch, searchResult);
    return _.join(
      _.filter(result, param => !isNullOrEmpty(param)),
      '、'
    );
  }, [state.params]);

  const { total, fieldId, tempParams, listFieldTree } = state;
  const {
    changeParamData,
    searchExecution,
    showDetail,
    clearParamsSearch,
  } = callbacks;

  const handleChangeTempParams = (name, values) =>
    changeParamData(name, values, 'tempParams');

  return (
    <div className='work-finish-report__search-form'>
      <Box sx={{ fontSize: '14px' }} className='search-form'>
        <Grid container rowSpacing='4px' columnSpacing={2} alignItems='center'>
          <Grid item xs='auto'>
            検索結果：
            <span className='bold'>{total}</span>件
          </Grid>
          <Grid item xs='auto'>
            <SearchFormElement label='協力会社'>
              <FieldTreeDropdown
                key={_.isEmpty(listFieldTree) ? 'loading' : 'loaded'}
                selectedValues={_.map(tempParams.field_trees, 'id')}
                selectedOptions={tempParams.field_trees}
                onSelect={(name, values) =>
                  handleChangeTempParams(name, values)
                }
                listFieldTree={listFieldTree}
                clearFlag={clearFlag}
              />
            </SearchFormElement>
          </Grid>

          <Grid item xs='auto'>
            <SearchFormElement label='元請担当者'>
              <ManagerUserDropdown
                fieldId={fieldId}
                selectedValues={_.map(tempParams.manager_users, 'user_id')}
                selectedOptions={tempParams.manager_users}
                onSelect={(name, values) =>
                  handleChangeTempParams(name, values)
                }
                clearFlag={clearFlag}
              />
            </SearchFormElement>
          </Grid>

          <Grid item xs='auto'>
            <SearchFormCheckbox
              name='status'
              stateName='tempParams'
              label={LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.NAME}
              value={LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.ID}
              param={tempParams}
              onChange={() =>
                handleChangeTempParams(
                  'status',
                  tempParams.status ===
                    LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.ID
                    ? LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.ALL.ID
                    : LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.ID
                )
              }
            />
          </Grid>

          <Grid item xs='auto'>
            <Stack direction='row' spacing={1.5} alignItems='center'>
              <button
                className='btn--sm--stay'
                onClick={searchExecution}
                ref={searchButtonRef}
              >
                {messageUtility.getMessage('I-000-164-09')}
              </button>
              <button className='btn-text--sm --font-200' onClick={showDetail}>
                {messageUtility.getMessage('I-000-268')}
              </button>
              <button
                className='btn-text--sm --font-200'
                onClick={clearParamsSearch}
              >
                {messageUtility.getMessage('I-000-211')}
              </button>
            </Stack>
          </Grid>
        </Grid>
        {displaySearchParams && (
          <Box className='nowrap' marginTop={1} lineHeight={1.5}>
            {displaySearchParams}
          </Box>
        )}
      </Box>
    </div>
  );
};

export const KyReportSearchFormDetail = ({ state, callbacks }) => {
  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false);
  const { timeZoneInfo, fieldId, tempParamsModal, listFieldTree } = state;
  const { changeParamData, clearTempParamsModal } = callbacks;

  const handleChangeTempParamsModal = (name, values) =>
    changeParamData(name, values, 'tempParamsModal');

  const changeDialogHeight = isOpen => {
    setIsOpenDatePicker(isOpen);
  };

  return (
    <div
      className={`work-finish-report__search-detail-modal ${
        isOpenDatePicker ? 'large-body' : ''
      }`}
    >
      <Grid container rowSpacing={1} columnSpacing={3}>
        <Grid item xs={12}>
          <SearchFormElement label='協力会社'>
            <Box width='674px' className='large-dropdown'>
              <FieldTreeDropdown
                dropdownSelectStyle={{ width: '100%' }}
                selectedValues={_.map(tempParamsModal.field_trees, 'id')}
                selectedOptions={tempParamsModal.field_trees}
                onSelect={(name, values) =>
                  handleChangeTempParamsModal(name, values)
                }
                listFieldTree={listFieldTree}
              />
            </Box>
          </SearchFormElement>
        </Grid>
        <Grid item xs={6}>
          <SearchFormElement label='元請担当者'>
            <Box width='286px' className='large-dropdown'>
              <ManagerUserDropdown
                fieldId={fieldId}
                dropdownSelectStyle={{ width: '100%' }}
                selectedValues={_.map(tempParamsModal.manager_users, 'user_id')}
                selectedOptions={tempParamsModal.manager_users}
                onSelect={(name, values) =>
                  handleChangeTempParamsModal(name, values)
                }
              />
            </Box>
          </SearchFormElement>
        </Grid>
        <Grid item xs={6}>
          <SearchFormCheckbox
            name='status'
            label={LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.NAME}
            value={LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.ID}
            param={tempParamsModal}
            onChange={() =>
              handleChangeTempParamsModal(
                'status',
                tempParamsModal.status ===
                  LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.ID
                  ? LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.ALL.ID
                  : LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.ID
              )
            }
          />
        </Grid>
        <Grid item xs={6}>
          <SearchFormElement label='日付'>
            <Box width='286px'>
              <ReactDropDownCalender
                onChange={date =>
                  handleChangeTempParamsModal('work_date', date)
                }
                value={tempParamsModal.work_date}
                datePickerSelectOnly={true}
                DisplayText={() => '日付を選択'}
                changeDialogHeight={changeDialogHeight}
              />
            </Box>
          </SearchFormElement>
        </Grid>
        <Grid item xs={6}>
          <SearchFormElement label='時間帯'>
            <Box width='286px' className='work-hour-zone--list'>
              <FormList>
                <FormElement>
                  <div className='form-list-radio'>
                    {timeZoneInfo.workHourZoneDayVisible && (
                      <div className='form-list-radio__item'>
                        <label className='radio'>
                          <input
                            type='radio'
                            checked={
                              tempParamsModal.work_hour_zone ===
                              WORK_HOUR_ZONES.day.id
                            }
                            onChange={() =>
                              handleChangeTempParamsModal(
                                'work_hour_zone',
                                WORK_HOUR_ZONES.day.id
                              )
                            }
                          />
                          <RadioButtonIcon className='icon--2x' />
                          <span>{WORK_HOUR_ZONES.day.name}</span>
                        </label>
                      </div>
                    )}
                    {timeZoneInfo.workHourZoneNightVisible && (
                      <div className='form-list-radio__item'>
                        <label className='radio'>
                          <input
                            type='radio'
                            checked={
                              tempParamsModal.work_hour_zone ===
                              WORK_HOUR_ZONES.night.id
                            }
                            onChange={() =>
                              handleChangeTempParamsModal(
                                'work_hour_zone',
                                WORK_HOUR_ZONES.night.id
                              )
                            }
                          />
                          <RadioButtonIcon className='icon--2x' />
                          <span>{WORK_HOUR_ZONES.night.name}</span>
                        </label>
                      </div>
                    )}
                    {timeZoneInfo.workHourZoneMidnightVisible && (
                      <div className='form-list-radio__item'>
                        <label className='radio'>
                          <input
                            type='radio'
                            checked={
                              tempParamsModal.work_hour_zone ===
                              WORK_HOUR_ZONES.midnight.id
                            }
                            onChange={() =>
                              handleChangeTempParamsModal(
                                'work_hour_zone',
                                WORK_HOUR_ZONES.midnight.id
                              )
                            }
                          />
                          <RadioButtonIcon className='icon--2x' />
                          <span>{WORK_HOUR_ZONES.midnight.name}</span>
                        </label>
                      </div>
                    )}
                  </div>
                </FormElement>
              </FormList>
            </Box>
          </SearchFormElement>
        </Grid>
      </Grid>
      <Stack direction='row-reverse' mt={1.5}>
        <button className='btn-text--sm --font-200' onClick={clearTempParamsModal}>
          検索内容をクリア
        </button>
      </Stack>
    </div>
  );
};

const filteredParams = paramSearch => {
  const listParamSearchDisplay = _.pick(paramSearch, [
    'work_date',
    'work_hour_zone',
  ]);
  return _.pickBy(listParamSearchDisplay, value => {
    return !isNullOrEmpty(value);
  });
};

const searchResult = (value, key) => {
  switch (key) {
    case 'work_hour_zone':
      return _.find(WORK_HOUR_ZONES, { id: value }).name;
    default:
      return value;
  }
};

/**
 * @description 検索フォーム_チェックボックス
 * @param {string} label
 * @param {number} name
 * @param {number} value
 * @param {object} param
 * @param {function} onChange
 */
const SearchFormCheckbox = ({ name, label, value, param, onChange }) => {
  return (
    <Box sx={{ display: 'flex' }} className='form-list-default'>
      <label htmlFor='checkbox' className='checkbox' onClick={onChange}>
        <input
          name='checkbox'
          type='checkbox'
          checked={param[name] === value}
          readOnly
        />
        <i className='i-3x' />
        <span>{label}</span>
      </label>
    </Box>
  );
};

/**
 * @description 検索フォームグループ
 * @param {string} label ラベル名
 * @param {*} children
 */
const SearchFormElement = ({ label, children }) => (
  <Stack
    direction='row'
    justifyContent='space-between'
    alignItems='center'
    spacing={1}
  >
    <span>{label}</span>
    {children}
  </Stack>
);

const FieldTreeDropdown = props => {
  const { listFieldTree, ...rest } = props;
  return (
    <DropdownSelector
      {...rest}
      label='協力会社を選択'
      multiple={true}
      selectorName='field_trees'
      api={async params => {
        if (params && params.name) {
          return _.filter(listFieldTree, fieldTree =>
            _.includes(
              _.toLower(fieldTree.company_name),
              _.toLower(_.trim(params.name))
            )
          );
        }
        return listFieldTree;
      }}
      apiProcess={response => {
        return {
          data: _.map(response, fieldTree => ({
            ...fieldTree,
            id: _.toString(fieldTree.id),
          })),
          total: response.length,
        };
      }}
      apiSearchKey='name'
      keyName='company_name'
      valueName='id'
      isSaveFullData={true}
    />
  );
};

const ManagerUserDropdown = props => {
  const { fieldId, ...rest } = props;
  return (
    <DropdownSelector
      {...rest}
      label='元請担当者を選択'
      multiple={true}
      selectorName='manager_users'
      api={params => FieldContractorUserService.list(fieldId, params)}
      apiParams={{
        field_id: fieldId,
        limit: REQUEST_PARAMS.parentLimit,
      }}
      apiSearchKey='name'
      keyName='user_name'
      valueName='user_id'
      apiBindDataKey={'field_contractor_users'}
      isSaveFullData={true}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/searchmenus/ListKyReportSearch.jsx